import React, { useState, useEffect, useRef, useContext } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { StoreContext } from "../../context/StoreContext"
import Utility from "../../objects/Utility"
import CloseX from "../CloseX/CloseX"
import './SaveCounterControl.scss'
const SaveCounterControl = ({ saveCounter, longName }) => {
    const controller = new AbortController();
    const { signal } = controller;
    const { state, actions } = useContext(StoreContext)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [saveName, setSaveName] = useState('')
    const saveCounterDialogRef = useRef(null)
    const saveCounterInputRef = useRef(null)
    const [message, setMessage] = useState({ text: '', color: '' })
    const [savedHash, setSavedHash] = useState('')
    const [selfActivatedOverlay, setSelfActivatedOverlay] = useState(false)
    const [savedLayerSvgs, setSavedLayerSvgs] = useState({front:'', rear:''})

    useEffect(() => {
        saveCounterDialogRef.current.addEventListener('mouseup', function (e) {
            e.stopPropagation();
        }, { signal });

        return () => {
            setMessage({ text: '', color: '' })
            setSaveName('')
            setSavedHash('')
            controller.abort();
        };
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     if (state.overlayClick) {
    //         setMessage({ text: '', color: '' })
    //         setSaveName('')
    //         setSavedHash('')
    //         setDialogOpen(false)
    //     }
    // }, [state.overlayClick])

    useEffect(() => {
        if (selfActivatedOverlay) {
            setSelfActivatedOverlay(false)
            close()
        }
    }, [state.windowWidthHeight]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (state.overlay === false && selfActivatedOverlay) {
            setSelfActivatedOverlay(false)
            close()
        }
    }, [state.overlay]) // eslint-disable-line react-hooks/exhaustive-deps


    const onNameChange = evt => {
        let checkedName = evt.target.value
        let _message = {}
        if (checkedName === '') {
            setSaveName('')
            return
        }
        let regexResult = checkedName.match(/[-_)( a-zA-Z0-9]+$/)
        if ((regexResult === null) || (regexResult && regexResult.index > 0)) {
            _message.text = "Only alpha-numeric, spaces, and - _ ) ('"
            _message.color = "red"
            setMessage(_message)
            return
        }
        _message.text = ''
        _message.color = ''
        setMessage(_message)

        setSaveName(evt.target.value)
    }

    const applyDateAndTime = () => {
        var currentdate = new Date();
        let mth = currentdate.getMonth() + 1
        if (mth < 10) {
            mth = '0' + mth
        }
        let yr = currentdate.getFullYear()
        let day = currentdate.getDate()
        let hour = currentdate.getHours()
        let min = currentdate.getMinutes()
        if (min < 10) {
            min = '0' + min
        }
        var datetime = `_${yr}-${mth}-${day}_${hour}-${min}`
        if (saveName.includes(datetime) === false) { // dont repeatedly insert it
            setSaveName(saveName + datetime)
        }
    }

    const close = () => {
        setMessage({ text: '', color: '' })
        setSaveName('')
        setSavedHash('')
        setDialogOpen(false)
    }

    const toggleDialog = () => {
        if (state.counterSideActive.front.length <= 250 && state.counterSideActive.rear.length <= 250) {
            return
        }
        setDialogOpen(!dialogOpen)
    }

    useEffect(() => {
        if (dialogOpen) {
            setSelfActivatedOverlay(true)
            actions.counterAreaMenuState('save counter')
            actions.overlay(true)
            saveCounterInputRef.current.focus()
        }
        else {
            if (state.counterAreaMenuState === 'save counter') {
                actions.counterAreaMenuState('')
                close()
            }
        }
    }, [dialogOpen]) // eslint-disable-line react-hooks/exhaustive-deps 

    useEffect(() => {
        if (state.counterAreaMenuState !== 'save counter' && dialogOpen) {
            toggleDialog()
        }
        if (state.counterAreaMenuState === '') {
            actions.overlay(false)
        }
    }, [state.counterAreaMenuState]) // eslint-disable-line react-hooks/exhaustive-deps

    const saveInAppCommit = async () => {
        if (saveName.length < 1) {
            return
        }

        // check if counter has already been saved
        for (const [key, value] of Object.entries(state.savedCounters)) { // eslint-disable-line no-unused-vars
            if (value.name === saveName) {
                let _message = {}
                _message.text = 'Name is already used'
                _message.color = 'red'
                setMessage(_message)
                return
            }
        }


        let packagedCounterState = packageCounterState('app')
        let hash = Utility.cyrb53(saveName, 'snapcounter3')
        setSavedHash(hash)
        let saveCounterObj = {}
        saveCounterObj[hash] = {
            hash: hash,
            name: saveName,
            layers: state.layers.filter(ly => ly.layerActive === 1),
            counterSideActive: state.counterSideActive,
            layerKeysOrdered: packagedCounterState.layerKeysOrdered,
            customImageSvgKeys: packagedCounterState.customImageSvgKeys,
            customSvgKeys: packagedCounterState.customSvgKeys,
            fonts: packagedCounterState.fonts,
            layerSvgs: packagedCounterState.layerSvgs,
            layersEffects: packagedCounterState.layersEffects,
            dateSaved: Utility.currentDate()
        }

        actions.savedCounters(saveCounterObj)
    }

    useEffect(() => {
        if (!Utility.emptyCheck(state.savedCounters)) {
            if (state.savedCounters[savedHash]) {
                let _message = {}
                _message.text = "Counter has been saved"
                _message.color = "green"
                setMessage(_message)
                setSavedHash('')
            }
        }
    }, [state.savedCounters]) // eslint-disable-line react-hooks/exhaustive-deps

    const saveToFileCommit = () => {
        if (saveName.length < 1) {
            return
        }
        let packagedCounterState = packageCounterState('file')
        let fileCounterObj = {
            fileName: saveName,
            version: 3,
            app: 'snapCounter',
            type: 'counter',
            savedAs: 'file',
            dateSaved: Utility.currentDate(),
            counterState: packagedCounterState
        }
        var zip = new JSZip();
        zip.file(saveName + ".json", JSON.stringify(fileCounterObj));
        zip.generateAsync({ type: "blob", compression: "DEFLATE" })
            .then(function (content) {
                // see FileSaver.js
                saveAs(content, saveName + '.scz');
                setMessage({ text: "Counter has been saved in zipped file format", color: "green" })
            });

    }

    const saveToSvgCommit = async () => {
        //let combinedSvg = combineSvgs()
        let combinedSvg = combineSvgsOnCounter()
        let blob = new Blob([combinedSvg], { type: 'image/svg+xml' });
        saveAs(blob, saveName + '.svg');
        setMessage({ text: "Counter has been exported in svg", color: "green" })
        //setDialogOpen(false)
    }

    const getImageDataURL = (image, type = 'png') => {
        if (type === 'jpg') type = 'jpeg';
        const { width, height } = image;
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        if (type === 'jpeg') {
            context.fillStyle = 'white';
            context.fillRect(0, 0, width, height);
        }
        context.drawImage(image, 0, 0, width, height);

        return canvas.toDataURL(`image/${type}`);
    }

    const convertSvg = (svgString, type = 'png') => new Promise((res, rej) => {
        const image = new Image();
        image.onload = () => res(getImageDataURL(image, type));
        image.src = `data:image/svg+xml,${encodeURIComponent(svgString)}`;
    });

    const saveToPngCommit = () => {
        // let source = combineSvgs()
        let source = combineSvgsOnCounter()
        convertSvg(source, 'png').then(dataURL => {
            /* do something with it */
            saveAs(dataURL, saveName + '.png');
            setMessage({ text: "Counter has been saved as a png", color: "green" })
            //setDialogOpen(false)
            // if (feedbackOnFocus === '') {
            //     setFeedbackOnFocus('saving ' + saveName + ' to png file.')
            // }
        });
    }

    const layerSvgsToArray = () => {
        let layerSvgs = []
        let _layers = [...state.layers]
        let activeLayers = _layers.sort((a, b) => a.layerOrder - b.layerOrder).filter(sl => sl.layerActive === 1)
        activeLayers.forEach(layer => {
            let id = 'drawLayer_' + layer.layerKey
            let layerEle = document.getElementById(id)
            if (layerEle) {
                let layerSvg = layerEle.innerHTML + "\n\n"
                if (layerSvg) {
                    layerSvgs.push(layerSvg)
                }
            }
        })

        return layerSvgs
    }

    const saveLayerSvgs = toSide => {
        let layerSvgs = []
        let _layers = [...state.layers]
        let activeLayers = _layers.sort((a, b) => a.layerOrder - b.layerOrder).filter(sl => sl.layerActive === 1)
        activeLayers.forEach(layer => {
            let id = 'drawLayer_' + layer.layerKey
            let layerEle = document.getElementById(id)
            if (layerEle) {
                let layerSvg = layerEle.innerHTML + "\n\n"
                if (layerSvg) {
                    layerSvgs.push(layerSvg)
                }
            }
        })

        if (layerSvgs.length > 0) {
            if (toSide === 'rear') {
                setSavedLayerSvgs({ ...savedLayerSvgs, front: layerSvgs })
            }
            else {
                setSavedLayerSvgs({ ...savedLayerSvgs, rear: layerSvgs })
            }
        }

        return layerSvgs
    }

    useEffect(() => {
        if (state.flippingCounter) {
            saveLayerSvgs(state.flippingCounter)
        }
    }, [state.flippingCounter]) // eslint-disable-line react-hooks/exhaustive-deps

    const combineSvgsOnCounter = () => {
        let _layers = [...state.layers]
        let activeLayers = _layers.sort((a, b) => a.layerOrder - b.layerOrder).filter(sl => sl.layerActive === 1)
        let fontsDetected = detectFonts(activeLayers)
        let fontsString = constructFontsString(fontsDetected)

        let utime = new Date().getTime()
        let builtUpSvg = '<svg id="combined_' + utime + '" xmlns="http://www.w3.org/2000/svg" width="1000" xmlns:xlink="http://www.w3.org/1999/xlink" height="1000" viewBox="20 20 200 200">'
        builtUpSvg += '<g transform="scale(1.2)">'

        // get the active layers 
        let layersOrder = activeLayers.map(ly => ly.layerActive ? { layerKey: ly.layerKey, layerOrder: ly.layerOrder } : null)
        layersOrder = layersOrder.filter(lo => lo)
        // drawLayer_ svgLayer
        layersOrder.forEach(alk => {
            let id = 'drawLayer_' + alk.layerKey
            builtUpSvg += document.getElementById(id).innerHTML + "\n\n"
        })
        builtUpSvg += '</g></svg>'

        if (fontsString) {
            builtUpSvg = insertFontsString(builtUpSvg, fontsString)
        }

        return builtUpSvg
    }

    const detectFontsBothSides = (frontAlv, rearAlv) => {
        let fontFamilies = []
        let frontActiveLayerKeys = Utility.activeLayerKeys(frontAlv)
        frontActiveLayerKeys.forEach(lk => {
            let originalLayerName = Utility.originalLayerNameLayerKey(state.layers, lk)
            if (originalLayerName === 'Google material symbols') {
                if (fontFamilies.includes('Material Icons') === false) {
                    fontFamilies.push('Material Icons')
                }
            }
            else {
                let layer = state.layers.find(sl => sl.layerKey === lk)
                if (layer) {
                    layer.inputs.forEach(ip => {
                        if (ip.named === 'font') {
                            if (frontAlv[layer.layerKey + '_' + ip.inputKey]) {
                                let fontFamily = frontAlv[layer.layerKey + '_' + ip.inputKey]
                                if (fontFamily) {
                                    if (fontFamilies.includes(fontFamily) === false) {
                                        fontFamilies.push(fontFamily)
                                    }
                                }

                            }
                        }
                    })
                }
            }
        })
        let rearActiveLayerKeys = Utility.activeLayerKeys(rearAlv)
        rearActiveLayerKeys.forEach(lk => {
            let originalLayerName = Utility.originalLayerNameLayerKey(state.layers, lk)
            if (originalLayerName === 'Google material symbols') {
                if (fontFamilies.includes('Material Icons') === false) {
                    fontFamilies.push('Material Icons')
                }
            }
            else {
                let layer = state.layers.find(sl => sl.layerKey === lk)
                if (layer) {
                    layer.inputs.forEach(ip => {
                        if (ip.named === 'font') {
                            if (rearAlv[layer.layerKey + '_' + ip.inputKey]) {
                                let fontFamily = rearAlv[layer.layerKey + '_' + ip.inputKey]
                                if (fontFamily) {
                                    if (fontFamilies.includes(fontFamily) === false) {
                                        fontFamilies.push(fontFamily)
                                    }
                                }

                            }
                        }
                    })
                }
            }
        })

        return fontFamilies
    }

    const detectFonts = activeLayers => {
        let fontFamilies = []
        let layers = [...state.layers]

        activeLayers.forEach(ly => {
            let originalLayerName = Utility.originalLayerName(layers, ly)
            if (originalLayerName === 'Google material symbols') {
                if (fontFamilies.includes('Material Icons') === false) {
                    fontFamilies.push('Material Icons')
                }
            }
            else {
                ly.inputs.forEach(ip => {
                    if (ip.named === 'font') {
                        if (state.activeLayerValues[ly.layerKey + '_' + ip.inputKey]) {
                            let fontFamily = state.activeLayerValues[ly.layerKey + '_' + ip.inputKey]
                            if (fontFamily) {
                                if (fontFamilies.includes(fontFamily) === false) {
                                    fontFamilies.push(fontFamily)
                                }
                            }
                        }
                    }
                })
            }
        })

        return fontFamilies
    }


    const packageCounterState = (saveType) => {
        let frontAlv = state.counterSideActive.front
        let rearAlv = state.counterSideActive.rear
        if (!frontAlv || !rearAlv) {
            console.error('invalid alv values from counterSideActive')
            return
        }
        frontAlv = JSON.parse(frontAlv)
        rearAlv = JSON.parse(rearAlv)

        // get images/svgs used
        // find any custom layers in state.layers
        let customImageLayers = []
        let customSvgLayers = []
        let customImageSvgKeys = []
        let customSvgKeys = []
        let customImageSvgsData = []
        let customSvgsData = []
        state.layers.forEach(ly => {
            if (Utility.isCustomImagesLayer2(ly, state.layers)) {
                customImageLayers.push(ly)
            }
            if (Utility.isCustomSvgsLayer2(ly, state.layers)) {
                customSvgLayers.push(ly)
            }
        })
        //let layerKeys = Utility.layerKeysActive(frontAlv)
        let layerKeys = Utility.layerKeysActiveBothSides(frontAlv, rearAlv)
        layerKeys.forEach(lk => {
            let found = customImageLayers.find(cil => cil.layerKey === lk)
            if (found) {
                let imageKey = frontAlv[lk + '_' + found.layerActiveRequiredInputKey]
                if (imageKey) {
                    if (customImageSvgKeys.includes(imageKey) === false) {
                        customImageSvgKeys.push(imageKey)
                    }
                }
            }
            found = customSvgLayers.find(cil => cil.layerKey === lk)
            if (found) {
                let svgKey = frontAlv[lk + '_' + found.layerActiveRequiredInputKey]
                if (svgKey) {
                    if (customSvgKeys.includes(svgKey) === false) {
                        customSvgKeys.push(svgKey)
                    }
                }
            }
        })

        //let activeLayers = _layers.sort((a, b) => a.layerOrder - b.layerOrder).filter(sl => sl.layerActive === 1)
        //let layersUsed = Utility.activeLayersBothSides(frontAlv, rearAlv, state.layers)

        let fontsDetected = detectFontsBothSides(frontAlv, rearAlv)


        let layersEffects = state.layersEffects.filter(sle => layerKeys.includes(sle.layerKey))

        if (saveType === 'file') {
            customImageSvgKeys.forEach(cik => {
                let found = state.svgs.find(svg => svg.svgKey === cik)
                if (found) {
                    customImageSvgsData.push(found)
                }
            })
            customSvgKeys.forEach(csk => {
                let found = state.svgs.find(svg => svg.svgKey === csk)
                if (found) {
                    customSvgsData.push(found)
                }
            })
            let layersUsed = state.layers.filter(sl => layerKeys.includes(sl.layerKey))

            let fontsData = packageFonts(fontsDetected)
            // file save
            return {
                counterSideActive: state.counterSideActive,
                layers: layersUsed,
                customImageSvgsData,
                customSvgsData,
                fontsData: fontsData,
                layersEffects: layersEffects
            }
        }
        else {
            // app save
            let combinedSvg = combineSvgsOnCounter()
            // get the current side of the counter, since the user may have been editing it.
            let layerSvgs = ''
            // we need the front for the Saved Counters display, since we only show the front side.
            if( state.counterSideActive.active === 'front' ) {
                layerSvgs = layerSvgsToArray()
            }
            else {
                layerSvgs = savedLayerSvgs.front
            }
            let layersSorted = state.layers.sort((a, b) => a.layerOrder - b.layerOrder)
            let layerKeysOrdered = layersSorted.map(ly => ly ? { layerKey: ly.layerKey, layerOrder: ly.layerOrder } : null)
            layerKeysOrdered = layerKeysOrdered.filter(lko => lko !== null)
            return {
                counterSideActive: state.counterSideActive,
                layerKeysOrdered,
                customImageSvgKeys,
                customSvgKeys,
                fonts: fontsDetected,
                combinedSvg,
                layerSvgs,
                layersEffects: layersEffects
            }
        }


    }

    const insertFontsString = (svgString, fontsString) => {
        let newSvgString = svgString
        let fontStyleString = fontsString
        if (fontStyleString) {
            let defSlashPos = newSvgString.indexOf('<defs/>')
            let defPos = newSvgString.indexOf('<defs>')
            // get the earliest one
            if (defSlashPos === -1) {
                defSlashPos = 99999999
            }
            if (defPos === -1) {
                defPos = 99999999
            }
            if (defSlashPos && (defSlashPos < defPos)) {
                newSvgString = newSvgString.replace('<defs/>', '<defs>' + fontStyleString + '</defs>')
            }
            if (defPos && (defPos < defSlashPos)) {
                newSvgString = newSvgString.substring(0, defPos + 6) + fontStyleString + newSvgString.substring(defPos + 6)
                //newSvgString = newSvgString.replace('<defs/>', fontStyleString + '<defs/>')
            }
        }

        return newSvgString
    }

    const packageFonts = fontFamilies => {
        let fontsData = []
        if (fontFamilies.length > 0) {
            for (let i = 0; i < fontFamilies.length; i++) {
                let fontFamily = fontFamilies[i]
                //let fontData = await Utility.getDexieStoreSingleItem(state.dexie, 'fonts', fontFamily, 'fontFamily')
                let fontData = state.fonts.find(sf => sf.fontFamily === fontFamily)
                if (fontData) {
                    fontsData.push(fontData)
                }
            }
        }
        return fontsData.length > 0 ? fontsData : null
    }

    const constructFontsString = fontFamilies => {
        let fontStyleString = ''
        if (fontFamilies.length > 0) {

            for (let i = 0; i < fontFamilies.length; i++) {
                let fontFamily = fontFamilies[i]
                //let fontData = await Utility.getDexieStoreSingleItem(state.dexie, 'fonts', fontFamily, 'fontFamily')
                let fontData = state.fonts.find(sf => sf.fontFamily === fontFamily)
                if (fontData) {
                    fontStyleString += "@font-face { font-family: '" + fontFamily + "'; "
                    fontStyleString += 'font-weight: ' + fontData.fontWeight + ';'
                    if (fontData.fontSrc.includes("format('woff2')") === false) {
                        fontStyleString += 'src: ' + fontData.fontSrc + " format('woff2');"
                    }
                    else {
                        fontStyleString += 'src: ' + fontData.fontSrc + ';'
                    }
                    fontStyleString += '} '
                    fontStyleString = fontStyleString.replaceAll(';;', ';')
                }

            }
            if (fontStyleString) {
                fontStyleString = '<style>' + fontStyleString + '</style>'
            }

        }
        return fontStyleString
    }

    const checkSaveCounterInAppIsPossible = () => {
        if( state.counterSideActive.active === 'front' ) {
            return true
        }
        if( savedLayerSvgs.front.length > 0 ) {
            return true
        }
    }

    return (
        <div className="save-counter-control">
            {/* <button className={state.counterSideActive.active === 'front' ? 'standard-button blue' : 'standard-button disabled'} onClick={state.counterSideActive.active === 'front' ? toggleDialog : null}>Save{longName ? ' Counter' : ''}</button> */}

            <button className={(state.counterSideActive.front.length > 250 || state.counterSideActive.rear.length > 250) ? 'standard-button blue' : 'standard-button disabled'} onClick={toggleDialog}>Save{longName ? ' Counter' : ''}</button>


            <div ref={saveCounterDialogRef} id="dialog" className={dialogOpen ? 'dialog' : 'display-none'}>
                <div className="title">
                    <div></div>
                    <div>Save Counter</div>
                    <CloseX close={toggleDialog} />
                </div>
                <div className="name-input">
                    <div className="apply-date-time" onClick={applyDateAndTime}>click to append date+time to name</div>
                    <div className="save-input-inline">

                        <div>save name:</div>
                        <div><input id="saveNameInput" className={message.color === "red" ? 'warning' : ''} ref={saveCounterInputRef} autoFocus={true} type="text"
                            value={saveName} onChange={onNameChange} /></div>
                    </div>
                </div>
                <div className="message-container">
                    <div className={`message ${message.color}`}>{message.text}</div>
                </div>
                <div className="save-counter-options-container">
                    <div className="save-counter-option">
                        <button className={saveName && checkSaveCounterInAppIsPossible() ? 'standard-button blue' : 'standard-button disabled'} onClick={saveName && checkSaveCounterInAppIsPossible() ? saveInAppCommit : null}>
                            save in app
                        </button>
                        <button className={saveName ? 'standard-button blue' : 'standard-button disabled'} onClick={saveName ? saveToFileCommit : null}>
                            save to file
                        </button>
                        <button className={saveName ? 'standard-button blue' : 'standard-button disabled'} onClick={saveName ? saveToSvgCommit : null}>
                            save to svg<span>*</span>
                        </button>
                        <button className={saveName ? 'standard-button blue' : 'standard-button disabled'} onClick={saveName ? saveToPngCommit : null}>
                            save to png<span>*</span>
                        </button>
                    </div>
                    {/*
                    <div className="save-counter-option">
                        <button className={saveName ? 'action-button cyanish' : 'action-button disabled'} onClick={saveName ? saveToFileCommit : null}>
                            save to file
                        </button>
                    </div>
                    <div className="save-counter-option">
                        <button className={saveName ? 'action-button cyanish' : 'action-button disabled'} onClick={saveName ? exportToSvgCommit : null}>
                            export to svg<span>*</span>
                        </button>
                    </div>
                    <div className="save-counter-option">
                        <button className={saveName ? 'action-button cyanish' : 'action-button disabled'} onClick={saveName ? exportToPngCommit : null}>
                            export to png<span>*</span>
                        </button>
    </div> */}
                </div>

                <div className="asterisk-explanation">
                    <span>*</span>These options are not importable back into the app.
                    <p>Note that with svg file exports, any fonts included in the svg file
                        will be ignored by most applications and editors, by default, due to
                        security and copyright concerns.</p>
                </div>
            </div>
        </div>
    )

}
export default SaveCounterControl

